import intl from "react-intl-universal";

const TABS = [
  { id: "overview", labelKey: "baas.api.tabs.overview" },
  { id: "logs", labelKey: "baas.api.tabs.logs" },
  { id: "api-keys", labelKey: "baas.api.tabs.apiKeys" },
  { id: "sla", labelKey: "baas.api.tabs.sla" },
  { id: "webhook", labelKey: "baas.api.tabs.webhook" },
];

export const BaasApiMonitoringTabs = ({ activeTab, onTabChange }) => (
  <div className="extract-view-tabs extract-view-tabs--inline" role="tablist" aria-label={intl.get("baas.api.monitoringSection")}>
    {TABS.map((tab) => {
      const isActive = activeTab === tab.id;
      return (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={isActive}
          className={`extract-view-tab ${isActive ? "extract-view-tab--active" : ""}`}
          onClick={() => onTabChange(tab.id)}
        >
          {intl.get(tab.labelKey)}
        </button>
      );
    })}
  </div>
);
